import {
    defaultLanguage,
    defaultTimezone,
    lsLanguage,
} from './userProfileContextHelpers';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extiende dayjs con el plugin para formatos personalizados
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);

export const dateLanguageFormats = {
    en: 'MM/DD/YYYY',
    fr: 'DD/MM/YYYY',
    es: 'DD/MM/YYYY',
    de: 'DD/MM/YYYY',
};

export const getLanguageFormat = lang => {
    let language;
    if (lang) {
        language = lang;
    } else if (lsLanguage) {
        //hay LS
        language = lsLanguage;
    } else {
        language = defaultLanguage;
    }
    return dateLanguageFormats[language];
};

export const formatDate = (date, lang) => {
    // es una fecha válida
    if (!date || (typeof date !== 'string' && !(date instanceof Date))) {
        return '--/--/--';
    }
    const parsedDate = new Date(date);
    if (
        isNaN(parsedDate) || // fecha inválida
        isMinValueDate(date) // fecha predeterminadas
    ) {
        return '--/--/--';
    }
    const languageFormat = getLanguageFormat(lang);
    return dayjs(date).format(languageFormat);
};

export const isMinValueDate = date => {
    return date === '0001-01-01T00:00:00';
};

export const formatDateYYMMDD = date => dayjs(date).format('YYYY/MM/DD');

export const formatUTCDateTime = (date, lang = 'es') => {
    const languageFormat = dateLanguageFormats[lang];
    const formatedDate = dayjs.utc(date).format(`${languageFormat} HH:mm:ss`);
    if (
        !date ||
        formatedDate === '01/01/0001' ||
        formatedDate === 'Invalid date'
    ) {
        return '--/--/--';
    } else {
        return formatedDate;
    }
};

export const getNextDay = date => {
    if (!date) return undefined;
    let currentDate = new Date(date);
    return currentDate.setDate(date.getDate() + 1);
};

export const getCurrentMonth = (date = new Date()) => {
    return dayjs(date).month();
};

export const getCurrentYear = (date = new Date()) => {
    return dayjs(date).year();
};

export const getYearPeriod = () => {
    //year ago = si estamos a 15 de mayo de 2023 => 01/06/2022
    const yearAgo = getYearAgoDate();
    // endThisMonth = si estamos a 15 de mayo de 2023 => 31/05/2023
    const endThisMonth = dayjs().endOf('month').format('YYYY-MM-DD');

    return { start: yearAgo, end: endThisMonth };
};

export const getMonthPeriod = (date = new Date()) => {
    //month ago = si estamos a 15 de mayo de 2023 => 15/04/2023

    const monthAgo = dayjs(date).subtract(1, 'months').format('YYYY-MM-DD');
    const endThisMonth = dayjs().endOf('month').format('YYYY-MM-DD');
    return { start: monthAgo, end: endThisMonth };
};

export const getYearAgoDate = () => {
    //Esta función devuelve la fecha del día uno del mes siguiente a la fecha de hace un año.
    const currentDate = dayjs();
    const yearAgo = currentDate.subtract(1, 'years');
    const firstOfNextMonth = yearAgo.add(1, 'months').startOf('month');
    return firstOfNextMonth.format('YYYY-MM-DD');
};

export const addMonthsToDate = (initialDate, numberOfMonths) => {
    return dayjs(initialDate)
        .add(numberOfMonths, 'months')
        .format('YYYY-MM-DD');
};

export const dateIsInRange = (stringDate, dateRange) => {
    const { start, end } = dateRange;
    return dayjs(stringDate).isBetween(start, end, null, '[)');
};

export const formatDateTime = (date, lang, timeZone = defaultTimezone) => {
    if (!date) {
        return '--/--/--, --:--:--';
    }

    const formatLanguage = getLanguageFormat(lang);

    // Convertimos la fecha a UTC, la ajustamos a la zona horaria y la formateamos
    const dateUtc = dayjs.utc(date).tz(timeZone);
    return dateUtc.format(`${formatLanguage}, HH:mm:ss`);
};

export const formatDateCard = date => {
    return dayjs(date).format('MM/YYYY');
};

export const convertDateToUTC = date => {
    return `${dayjs(date).format('YYYY-MM-DD')}T00:00:00`;
};

export const getTodayDate = () => {
    return new Date().toISOString().substring(0, 19);
};

export const formatCreditCardExpireDate = date => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format('MM/YY') : '--/--';
};
